var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showDialog
    ? _c("v-dialog", {
        attrs: { persistent: "", scrollable: "", "max-width": "600px" },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function () {
                return [
                  _c(
                    "v-card",
                    { staticClass: "modal-add-folder" },
                    [
                      _c(
                        "header",
                        { staticClass: "header" },
                        [
                          _c(_setup.CustomDialogHeaderComponent, {
                            attrs: { headerTitle: _setup.texts.title },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        { staticStyle: { height: "450px" } },
                        [
                          _c(_setup.TemplateSelectorTreeComponent, {
                            key: _setup.componentKey,
                            attrs: {
                              idEntityType: _vm.idEntityType,
                              loading: _setup.treeLoading,
                              generateTemplate: _setup.generatingTemplate,
                            },
                            on: {
                              templateSelected: _setup.getTemplateSelected,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-card-actions", { staticClass: "modal-footer" }, [
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button secondary-action-button",
                              attrs: { title: _setup.texts.cancel },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _setup.close.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_setup.texts.cancel) + " ")]
                          ),
                          _setup.hasSelectedTemplate
                            ? _c(
                                "button",
                                {
                                  staticClass: "button main-action-button",
                                  attrs: { title: _setup.texts.generate },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _setup.generate.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_setup.texts.generate) + " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          4115942473
        ),
        model: {
          value: _vm.showDialog,
          callback: function ($$v) {
            _vm.showDialog = $$v
          },
          expression: "showDialog",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }